
import { defineComponent, reactive, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";

import ShopCard from "../components/ShopCardView.vue"; // @ is an alias to /src
import ShopCart from "../components/ShopCart.vue";
import { getProductList, getProductTag } from "@/api/shopApi";

export default defineComponent({
    setup() {
        const router = useRouter();
        const show = ref(false);

        // const active = ref(0);
        const state = reactive({
            id: "",
            tagList: [],
            tagArr: [],
            value: 1,
            text: "",
        });
        const option = [
            { text: "商品", value: 1 },
            { text: "服务", value: 2 },
        ];

        const { proxy } = getCurrentInstance();

        return {
            // active,
            show,
            state,
            option,
            router, //一定要要放在return里才能在模板上面使用
            $globalBus: proxy.$globalBus,
        };
    },
    name: "PageSearchResult",
    components: { ShopCard, ShopCart },
    props: {
        wd: {
            type: String,
        },
    },
    watch: {
        active() {
            // console.log(arguments);
            this.reLoad();
        },
    },
    activated() {
        // this.lockLoadData = true;
        // if (this.$route.query.productType) {
        //     this.state.value = parseInt(this.$route.query.productType);
        // } else {
        //     this.state.value = 1;
        // }
        // // this.LoadData();
        // this.LoadTag(this.$route.query.id ? this.$route.query.id : "0");
        
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.lockLoadData = true;
            if (this.$route.query.productType) {
                this.state.value = parseInt(this.$route.query.productType);
            } else {
                this.state.value = 1;
            }
            // this.LoadData();
            this.LoadTag(this.$route.query.id ? this.$route.query.id : "0");
        },
        filter() {
            this.show = true;
        },
        reLoad() {
            this.productClassifyId = this.active == "0" ? "" : this.active;
            if (this.$refs.appList) {
                if (this.lockLoadData) {
                    return;
                }
                this.$refs.appList.refresh();
            }
        },
        async LoadData({ index, setData }) {
            if (this.state.value == 1) {
                this.state.text = "请输入商品名称";
            } else {
                this.state.text = "请输入服务名称";
            }
            const list = (await getProductList(
                this.state.value,
                index,
                10,
                this.productClassifyId
            )) as any;
            const arr = list.rows;
            setData(arr, list.total);
        },
        async LoadTag(active: any) {
            var tag = (await getProductTag(this.state.value)) as any;
            this.state.tagList = tag;
            this.state.tagArr = Object.assign([], tag);
            await this.$nextTick();
            this.lockLoadData = false;
            console.warn("取消锁", this.active, active);
            if (this.active == active) {
                this.reLoad();
            } else {
                this.active = active;
            }

            const curIndex = this.state.tagList.findIndex((item: any) => {
                return item.id == this.active;
            })
            // 初始化时获取tab的名字
            let title = this.$route.meta.pageTitle;
            if (curIndex > -1) {
                // 综合代表的是0，在列表中不会存在0，所以当index<-1时就使用路由上的title;
                title = this.state.tagList[curIndex].value;
            }
            this.$globalBus.emit('changeTitle', title);
        },
        // 商品和服务大类切换
        async onChange() {
            await this.LoadTag("0");
        },
        itemClick(item: { show: boolean; id: any }) {
            item.show = !item.show;
            if (!item.show) {
                this.state.tagList.push(item);
            } else {
                const index = this.state.tagList.findIndex(
                    (a: { id: any }) => a.id === item.id
                );
                this.state.tagList.splice(index, 1);
            }
        },
        close() {
            const ids = [];
            this.state.tagList.forEach((item: { id: any }) => {
                ids.push(item.id);
            });
            this.productClassifyId = ids.join(",");
            // this.LoadData();
            if (this.$refs.appList) {
                this.$refs.appList.refresh();
            }
        },
        addToShopCart(event: { target: any }, item: any) {
            // 通知后台，回调成功后执行下面的函数
            this.$refs.cart.drop(event.target, item);
        },
        goToCart() {
            this.router.push(`/shop/cart/home`);
        },
        changeTab(name: string | number, title: string) {
            if (this.active == 0) title = this.$route.meta.pageTitle
            this.$globalBus.emit('changeTitle', title);
        },
    },
    data() {
        return {
            // 因为各种出发加载数据的接口，导致参数传错，所以增加锁的机制，如果是true,则丢弃请求
            lockLoadData: false,
            appListEls: [],
            active: "0",
            productClassifyId: "",
        };
    },
});
